import React, { useEffect, useReducer } from 'react';
import Routes from './routes';
import { AuthContext } from './auth/AuthContext'
import { authReducer } from './auth/authReducer'
import SessionFactory from './factories/Session';
import { CartContext } from './cart/CartContext'
import { cartReducer } from './cart/cartReducer'
import CartFactory from './factories/Cart';
import './scss/styles.scss';

const initSession = () => {
    return SessionFactory.validation() || { logged: false };
}

const initCart = () => {
    return CartFactory.validation() || CartFactory.reset();
}

export const App = () => {
    const [ sessionData, sessionDispatch ] = useReducer(authReducer, {}, initSession);
    const [ cartData, cartDispatch ] = useReducer(cartReducer, {}, initCart);

    useEffect(() => {
        SessionFactory.save(sessionData);
    }, [sessionData]);

    useEffect(() => {
        CartFactory.save(cartData);
    }, [cartData]);

    return (
        <AuthContext.Provider value={{ sessionData, sessionDispatch }}>
            <CartContext.Provider value={{ cartData, cartDispatch }}>
                <Routes />
            </CartContext.Provider>
        </AuthContext.Provider>
    );
}

export default App;

